import { cargoReleaseCreateTypes } from './actionTypes';

const INIT_STATE = {
data:[],
ReleaseList :[],
CargoRelaseNumber:"",
BillingReleaseList:[],
CarrierList:[],
addressByEntity: {},
filters:[],
CountItems:[],
isLoading: false,
error: {},
};

const cargoReleaseCreation = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case cargoReleaseCreateTypes.GET_FiltersCreateCR:
      return {
        ...state,
        isLoading: true,
      };
    case cargoReleaseCreateTypes.GET_FiltersCreateCR_SUCCESS:
      return {
        ...state,
        BillingReleaseList: action.payload.BillingClientList,
        CarrierList:action.payload.CarrierList,
        ReleaseList:action.payload.ReleaseList,
        CargoRelaseNumber:action.payload.CargoRelaseNumber,
        isLoading: false,
      };

    case cargoReleaseCreateTypes.GET_FiltersCreateCR_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
//-------------------------------------Create-------------------------------------------
      case cargoReleaseCreateTypes.CREATE_CR_SUCCESS:
        return {
          ...state,
          isLoading: false,
        };

      case cargoReleaseCreateTypes.CREATE_CR_FAIL:
        return {
          ...state,
          error: action.payload,
          isLoading: false,
        };
//-----------------------------------get filter-----------------------------------------

        case cargoReleaseCreateTypes.GET_FiltersListItemAggregation:
          return {
            ...state,
            isLoading: true,
          };
        case cargoReleaseCreateTypes.GET_FiltersListItemAggregation_SUCCESS:
          return {
            ...state,
            filters: action.payload.filterItems,
            isLoading: false,
          };

        case cargoReleaseCreateTypes.GET_FiltersListItemAggregation_FAIL:
          return {
            ...state,
            error: action.payload,
            isLoading: false,
          };
//---------------------------GET ITEMS----------------------------------------------
        case cargoReleaseCreateTypes.GET_COMMODITY_DEFINITIONS:
          return {
            ...state,
            isLoading: true,
          };
        case cargoReleaseCreateTypes.GET_COMMODITY_SUCCESS:
          return {
            ...state,
            data: action.payload?.comodityData,
            CountItems: action.payload?.CountItems,
            isLoading: false,
          };

        case cargoReleaseCreateTypes.GET_COMMODITY_FAIL:
          return {
            ...state,
            error: action.payload,
            isLoading: false,
  };
  //---------------------------GET Addresss----------------------------------------------
  case cargoReleaseCreateTypes.GET_ADDRESS_BY_ENTITY_NAME:
    return {
      ...state
    };
  case cargoReleaseCreateTypes.GET_ADDRESS_BY_ENTITY_NAME_SUCCESS:
    return {
      ...state,
      addressByEntity: action.payload
    };

  case cargoReleaseCreateTypes.GET_ADDRESS_BY_ENTITY_NAME_FAIL:
    return {
      ...state,
      error: action.payload,
};

    default:
      return state;
  }
};

export default cargoReleaseCreation;
